import { z } from 'zod/v4';

import { Currency } from '../currencyBackendTypes';
import { SupplierDTORuntype, SupplierPartType, SupplierType } from '../supplier/supplierBackendTypes';
import { RegionsEnumRuntype } from './regions';

export { RegionsEnum, RegionsEnumRuntype } from './regions';

export enum SupplierTag {
    QuotePartner = 'QuotePartner',
    ManuallyAdded = 'ManuallyAdded',
    OffTheShelfPartSupplier = 'OffTheShelfPartSupplier',
    PcbSupplier = 'PcbSupplier',
    CustomPartSupplier = 'CustomPartSupplier',
    AssemblySupplier = 'AssemblySupplier',
    Distributor = 'Distributor',
    Manufacturer = 'Manufacturer',
    Ems = 'Ems',
    System = 'System',
    Erp = 'Erp',
    Manual = 'Manual',
}

export enum SupplierPreference {
    Preferred = 'Preferred',
    Approved = 'Approved',
    NotApproved = 'NotApproved',
    Excluded = 'Excluded',
}

const TagRuntype = z.object({
    tag: z.enum(SupplierTag),
});

export const SupplierPreferenceRuntype = z.enum(SupplierPreference);

export interface SupplierAndStockLocationDTO extends z.infer<typeof SupplierAndStockLocationDTORuntype> {}
export const SupplierAndStockLocationDTORuntype = z.object({
    id: z.string(),
    supplier: SupplierDTORuntype,
    stock_location: RegionsEnumRuntype,
    supplier_number: z.string().nullable(),
    tags: z.array(TagRuntype),
    shipping_time_in_days: z.number().nullable(),
});

export interface SupplierAndStockLocationWithPreferenceDTO extends SupplierAndStockLocationDTO {
    preference: SupplierPreference;
}

export interface SupplierAndStockLocationPostDTO extends z.infer<typeof SupplierAndStockLocationPostDTORuntype> {}
export const SupplierAndStockLocationPostDTORuntype = z.object({
    name: z.string(),
    stock_location: RegionsEnumRuntype,
    supplier_number: z.string().nullable(),
    supplier_type: z.enum(SupplierType),
    supplier_part_type: z.enum(SupplierPartType),
    supplier_preference: z.optional(SupplierPreferenceRuntype),
    shipping_time_in_days: z.number().nullable(),
    default_currency: z.enum(Currency).optional(),
});

export interface SupplierAndStockLocationPatchDTO extends z.infer<typeof SupplierAndStockLocationPatchDTORuntype> {}
export const SupplierAndStockLocationPatchDTORuntype = z.object({
    name: z.string().optional(),
    supplier_number: z.string().nullable(),
    supplier_type: z.enum(SupplierType).optional(),
    supplier_part_type: z.enum(SupplierPartType).optional(),
    supplier_preference: z.optional(SupplierPreferenceRuntype),
    shipping_time_in_days: z.number().nullable().optional(),
    default_currency: z.enum(Currency).optional(),
});

export type SupplierAndStockLocationFilterRequest = z.infer<typeof SupplierAndStockLocationFilterRequestRuntype>;
export const SupplierAndStockLocationFilterRequestRuntype = z.union([
    z.object({
        field: z.literal('supplier_preference'),
        operator: z.literal('equalsAny'),
        parameter: z.array(SupplierPreferenceRuntype),
    }),
]);
